namespace $.$$ {

	type $shm_ba_report_renderer_make_config = Record< string, any >
	type $shm_ba_report_sql = (( strings: TemplateStringsArray | string, ...values: any[] )=> $shm_ba_data_table ) & {
		text: ( value: unknown )=> string
		ident: ( name: string )=> string
	}

	export class $shm_ba_report_renderer extends $.$shm_ba_report_renderer {

		empty_text() {
			return [
				'# Отчет пуст',
				'',
				'Агент справа может записать JS-код отчета через MCP.',
			].join( '\n' )
		}

		rows() {
			const code = this.report()?.js_code().trim() ?? ''
			if( !code ) return [ this.Empty() ]
			return [ this.rendered() ]
		}

		@ $mol_mem
		rendered() {
			const view = this.run_code()
			return this.view_normalize( view )
		}

		run_code() {
			this.$.$shm_hitalama_compat_fqn_install( this.$ as any )
			const code = this.report()?.js_code() ?? ''
			const run = new Function(
				'$',
				'$' + 'make',
				'$' + 'view_data',
				'$' + 'dashboard',
				'$' + 'report',
				'$' + 'filters',
				'$' + 'tables',
				'$' + 'query',
				'$' + 'sql',
				'$' + 'summary',
				'$' + 'posts',
				'$' + 'timeseries',
				'$' + 'tags',
				'$' + 'authors',
				'$' + 'sources',
				code,
			)

			return run(
				this.$,
				this.make_factory(),
				this.view_data_factory(),
				this.dashboard_context(),
				this.report_context(),
				this.filters_context(),
				this.tables_context(),
				( sql: string )=> this.query_sql( sql ),
				this.sql_factory(),
				()=> this.dashboard()?.query_summary(),
				()=> this.dashboard()?.query_posts(),
				()=> this.dashboard()?.chart_timeseries(),
				()=> ( this.dashboard() as any )?.tags?.(),
				()=> ( this.dashboard() as any )?.authors?.(),
				()=> ( this.dashboard() as any )?.sources?.(),
			)
		}

		table_empty(): $shm_ba_data_table {
			return { head: [], rows: [] }
		}

		query_sql( sql: string ) {
			return ( this.dashboard() as any )?.query_sql?.( sql ) ?? this.table_empty()
		}

		sql_factory(): $shm_ba_report_sql {
			const sql = ( ( strings: TemplateStringsArray | string, ...values: any[] )=> {
				if( typeof strings === 'string' ) return this.query_sql( strings )
				const text = strings.reduce(
					( result, chunk, index )=> result + chunk + ( index < values.length ? String( values[ index ] ) : '' ),
					'',
				)
				return this.query_sql( text )
			} ) as $shm_ba_report_sql
			sql.text = value => ( this.dashboard() as any )?.data?.().sql_text( value ) ?? "''"
			sql.ident = name => ( this.dashboard() as any )?.data?.().sql_ident( name ) ?? `"${ String( name ).replaceAll( '"', '""' ) }"`
			return sql
		}

		view_normalize( value: any ): $mol_view | string {
			if( value instanceof this.$.$mol_view ) return this.view_stretch( value )
			if( value instanceof Node ) {
				return this.view_stretch( this.make_factory()( this.$.$mol_view, {
					dom_name: ()=> 'div',
					sub: ()=> [ value ],
				} ) )
			}
			if( typeof value === 'string' ) return value
			return this.view_stretch( this.make_factory()( this.$.$mol_text_code, {
				text: ()=> JSON.stringify( value, null, '\t' ),
			} ) )
		}
		
		view_stretch< View extends $mol_view >( view: View ) {
			const style = view.style.bind( view )
			view.style = ()=> ({
				... style(),
				width: '100%',
				minWidth: 0,
				flex: '1 1 auto',
			})
			return view
		}

		make_factory() {
			return < View extends typeof $mol_view >( View: View, config: $shm_ba_report_renderer_make_config = {} )=> {
				const obj = new View() as InstanceType< View >
				for( const key of Object.keys( config ) ) {
					const value = config[ key ]
					;( obj as any )[ key ] = typeof value === 'function' ? value : ()=> value
				}
				return obj
			}
		}

		view_data_factory() {
			return ( key: string, fallback?: any )=> {
				return ( next?: any )=> {
					const storage_key = this.storage_key( key )
					if( next !== undefined ) return this.view_data( storage_key, next )
					const value = this.view_data( storage_key )
					return value === undefined ? this.view_data( storage_key, fallback ) : value
				}
			}
		}

		storage_key( key: string ) {
			return [
				this.dashboard()?.app_id() ?? '',
				this.report()?.id() ?? '',
				key,
			].join( '\n' )
		}

		@ $mol_mem_key
		view_data( key: string, next?: any ) {
			return next
		}

		dashboard_context() {
			const dashboard = this.dashboard()
			return {
				id: dashboard?.app_id() ?? '',
				title: dashboard?.dashboard_title() ?? '',
				file_uri: dashboard?.file_uri() ?? '',
				has_source: dashboard?.has_source() ?? false,
				period: dashboard?.period() ?? null,
				period_all: dashboard?.period_all() ?? null,
			}
		}

		report_context() {
			const report = this.report()
			return {
				id: report?.id() ?? '',
				title: report?.title() ?? '',
			}
		}

		filters_context() {
			const dashboard = this.dashboard()
			return {
				tags: dashboard?.tags_filter() ?? {},
				authors: dashboard?.authors_filter() ?? {},
				sources: dashboard?.sources_filter() ?? {},
				search_query: dashboard?.search_query() ?? '',
				search_mode: dashboard?.search_mode() ?? '',
				search_case_sensitive: dashboard?.search_case_sensitive() ?? true,
				chart_metric: dashboard?.chart_metric() ?? '',
				chart_group: dashboard?.chart_group() ?? '',
				posts_sort: dashboard?.posts_sort() ?? '',
				posts_sort_order: dashboard?.posts_sort_order() ?? '',
			}
		}

		tables_context() {
			return ( this.dashboard() as any )?.query_tables?.() ?? {
				messages: 'ba_messages',
				source: 'ba_messages',
				filtered: 'ba_messages_filtered_ids',
				tags: 'ba_message_tags',
			}
		}

	}

}
